const _excluded = ["children", "className", "disabled", "focused", "ghost", "hovered", "invalid", "padding", "radius", "selected", "size", "width"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import classNames from 'clsx';
import { PressableCore, PressableThemeContext, PressableThemeProvider, defaultPressableTheme, defaultPressableTheme2021 } from "./";
const {
  useContext
} = React;
const monochromeTheme = {
  keyline: {
    primary: '#2a2f45'
  },
  color: {
    primary: '#1a1f36',
    default: '#697386'
  }
};
const PressableToggle = props => {
  const {
      children,
      className,
      disabled = false,
      focused = false,
      ghost = false,
      hovered = false,
      invalid = false,
      padding,
      radius = 'none',
      selected = false,
      size = 'medium',
      width = 'auto'
    } = props,
    remaining = _objectWithoutProperties(props, _excluded);
  const getColor = () => {
    if (invalid) {
      return 'negative';
    } else if (selected) {
      return 'primary';
    } else if (disabled) {
      return 'disabled';
    }
    return hovered ? 'hover' : 'default';
  };
  const getCursor = () => {
    return disabled ? 'default' : 'pointer';
  };
  const getFill = () => {
    return ghost ? 'none' : 'base';
  };
  const getFontLineHeight = () => {
    if (size === 'small') {
      return 16;
    } else if (size === 'jumbo' || size === 'large') {
      return 24;
    }
    return 20;
  };
  const getFontSize = () => {
    if (size === 'small') {
      return 13;
    } else if (size === 'jumbo' || size === 'large') {
      return 16;
    }
    return 14;
  };
  const getKeylineColor = () => {
    if (invalid) {
      return 'negative';
    }
    return selected ? 'primary' : 'base';
  };
  const getKeyline = () => {
    return ghost && !selected ? 'none' : {
      color: getKeylineColor(),
      side: 'all',
      width: selected ? 2 : 1
    };
  };
  const getPadding = () => {
    if (padding) {
      return padding;
    } else if (size === 'jumbo') {
      return {
        horizontal: 16,
        vertical: 8
      };
    } else if (size === 'large') {
      return {
        horizontal: 12,
        vertical: 4
      };
    } else if (size === 'medium' || size === 'small') {
      return {
        horizontal: 8,
        vertical: 4
      };
    }
  };
  const getShadow = () => {
    return ghost ? {
      focused
    } : {
      base: true,
      hovered,
      focused
    };
  };
  const classes = classNames('PressableToggle', className);

  // PressableToggle doesn't support theming yet. We set a monochrome
  // theme if a custom theme is provided.
  const pressableTheme = useContext(PressableThemeContext);
  const hasCustomTheme = [defaultPressableTheme, defaultPressableTheme2021].indexOf(pressableTheme) === -1;
  const toggleTheme = hasCustomTheme ? monochromeTheme : pressableTheme;
  return /*#__PURE__*/React.createElement(PressableThemeProvider, {
    theme: toggleTheme
  }, /*#__PURE__*/React.createElement(PressableCore, _extends({}, remaining, {
    className: classes,
    color: getColor(),
    cursor: getCursor(),
    fill: getFill(),
    fontLineHeight: getFontLineHeight(),
    fontSize: getFontSize(),
    fontWeight: "medium",
    height: size
    // @ts-expect-error - TS2322 - Type '"none" | { color: string; side: string; width: number; }' is not assignable to type '"none" | PressableCoreKeylineMap | undefined'.
    ,
    keyline: getKeyline(),
    overlay: !!disabled
    // @ts-expect-error - TS2322 - Type 'SpacingMap | { horizontal: number; vertical: number; } | undefined' is not assignable to type 'SpacingMap | undefined'.
    ,
    padding: getPadding(),
    radius: radius,
    shadow: getShadow(),
    width: width
  }), children));
};
export default PressableToggle;